// extracted by mini-css-extract-plugin
export default {"verdictWrapper":"NCmsc7uj","mobile":"mobile","verdictTitle":"avWJtDvk","text":"VVOCB8GK"};